import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CustomerIdentDocumentModel} from '../../../models/customer-ident-document-model';

@Component({
  selector: 'app-customer-ident-edit-dialog',
  templateUrl: './customer-ident-edit-dialog.component.html',
  styleUrls: ['./customer-ident-edit-dialog.component.css']
})
export class CustomerIdentEditDialogComponent implements OnInit {
  public title = 'Edit Ident Document';
  public text = 'Please enter the new document data';

  constructor(
    public dialogRef: MatDialogRef<CustomerIdentEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CustomerIdentDocumentModel
  ) { }

  ngOnInit() {


  }

  onYesClick(): void {

    this.dialogRef.close(this.data);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
